import { Type } from 'class-transformer';
import { UserNameDisplayResultDto } from '../../_models/user-name-display-result-dto';
import { AccItemDetailResultDto } from '../../shared-acc-board-approval-module/_models/acc-item-detail-result-dto';

export class AccProjectDetailResultDto {
    accId: number;
    property: string;
    communityId: number;
    community: string;
    owner: string;
    description: string;

    @Type(() => Date)
    receivedDate: Date;

    assignedTo: string;

    @Type(() => UserNameDisplayResultDto)
    lastModifiedBy: UserNameDisplayResultDto;

    @Type(() => Date)
    lastModifiedDate: Date;

    @Type(() => Date)
    projectClosedOn: Date;

    projectDocumentCount: number;

    @Type(() => AccItemDetailResultDto)
    items: AccItemDetailResultDto[];

    boardApprovalRules: string;
    isCurrentOwner: boolean;
}
